import { MessageCircle } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const FloatingChatButton = () => {
  const location = useLocation();
  const { t } = useTranslation();

  if (location.pathname === "/chat" || location.pathname === "/admin") {
    return null;
  }

  return (
    <Link
      to="/chat"
      className={cn(
        "fixed bottom-6 left-6 z-50",
        "w-14 h-14 rounded-full",
        "bg-primary hover:bg-primary/90 shadow-lg hover:shadow-xl",
        "flex items-center justify-center",
        "transition-all duration-300 hover:scale-110",
        "group"
      )}
      title={t('chat.chatWithAI')}
    >
      <MessageCircle className="w-6 h-6 text-primary-foreground" />
      <span className="absolute left-full mr-3 px-3 py-1.5 bg-foreground text-background text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        {t('chat.chatWithAI')}
      </span>
      <span className="absolute inset-0 rounded-full bg-primary animate-ping opacity-20" />
    </Link>
  );
};

export default FloatingChatButton;
